import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { BigLineSeparator } from '../../../components/separator/LineSeparator';
import { LawFirmHeaderInfos } from '../header/LawFirmHeaderInfos';
import '../header/law_firm_header.scss';
import { Office } from '../../lawFirm.types';
import { Hyperlink } from '../../../components/Hyperlink';
import { buildUrlWithParameters } from '../../../utils/url-utils/urlUtils';
import { EntityCardHeader } from '../../../entity/components/EntityCardComponents';

type Props = {
  firmName: string;
  office: Office;
  firmLink: string;
};

export const OfficeHeader: FC<Props> = ({
  firmName,
  office,
  office: { dateRadiation, ville },
  firmLink,
}) => (
  <EntityCardHeader id="law-firm-header">
    <div className="law-firm-header__top-container">
      <div
        className="entity__header__picture law-firm-header__picture"
        style={{ backgroundImage: 'url(/img/icons/entities/law-firm.svg)' }}
      />
      <div className="law-firm-header__title-container">
        <h1 className="entity__header__title law-firm-header__title">
          {firmName} {ville}
        </h1>
        <span className="law-firm-header__title-info">
          <FormattedMessage id="law-firm/page/office/OfficeHeader.tsx/1" />{' '}
          {dateRadiation ? (
            <span className="law-firm-header__info-important">
              <FormattedMessage id="law-firm/page/office/OfficeHeader.tsx/2" />
              {dateRadiation}
            </span>
          ) : (
            ''
          )}{' '}
          <FormattedMessage id="law-firm/page/office/OfficeHeader.tsx/3" />{' '}
          <Hyperlink
            className="law-firm-header__link"
            href={buildUrlWithParameters(firmLink, {
              source: 'office_header',
            })}
          >
            {firmName}
          </Hyperlink>
        </span>
      </div>
    </div>
    <BigLineSeparator />
    <LawFirmHeaderInfos office={office} />
  </EntityCardHeader>
);
